import { render, staticRenderFns } from "./SearchUsergroups.vue?vue&type=template&id=417490b7&scoped=true"
import script from "./SearchUsergroups.vue?vue&type=script&lang=js"
export * from "./SearchUsergroups.vue?vue&type=script&lang=js"
import style0 from "./SearchUsergroups.vue?vue&type=style&index=0&id=417490b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417490b7",
  null
  
)

export default component.exports